var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReporting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 10.2C6.15817 9.86863 5.53137 9.95817 5.2 10.4C4.86863 10.8418 4.95817 11.4686 5.4 11.8L6.6 10.2ZM10 14L9.4 14.8L10.2188 15.4141L10.8137 14.5812L10 14ZM15.8137 7.58124C16.1347 7.13183 16.0307 6.50728 15.5812 6.18627C15.1318 5.86526 14.5073 5.96935 14.1863 6.41876L15.8137 7.58124ZM11 22C17.0753 22 22 17.0753 22 11H20C20 15.9707 15.9707 20 11 20V22ZM22 11C22 4.92472 17.0753 0 11 0V2C15.9707 2 20 6.02928 20 11H22ZM11 0C4.92472 0 0 4.92472 0 11H2C2 6.02928 6.02928 2 11 2V0ZM0 11C0 17.0753 4.92472 22 11 22V20C6.02928 20 2 15.9707 2 11H0ZM5.4 11.8L9.4 14.8L10.6 13.2L6.6 10.2L5.4 11.8ZM10.8137 14.5812L15.8137 7.58124L14.1863 6.41876L9.18627 13.4188L10.8137 14.5812Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReporting);
export default __webpack_public_path__ + "static/media/reporting.8a07d03e53192b7042abb9093c239ecd.svg";
export { ForwardRef as ReactComponent };